import styled from '@emotion/styled';

export const WelcomeDiv = styled.div`
  h2 {
    display: inline;
  }
`;

export const BoldSpan = styled.span`
  font-weight: 700;
`;

export const CardWrapper = styled.div`
  width: 100%;
`;
